(function () {
  var root = document.querySelector('[data-cjb]');
  if (!root) return;

  var variants = JSON.parse(root.dataset.variants || '[]');
  var options = JSON.parse(root.dataset.options || '[]');
  var zones = {};
  try { zones = JSON.parse(root.dataset.zones || '{}'); } catch (e) { zones = {}; }
  var moq = parseInt(root.dataset.moq, 10) || 1;
  var moneyFormat = root.dataset.moneyFormat || '₹{{amount}}';

  var selected = options.map(function (o) { return o.values[0]; });
  var baseImg = root.querySelector('[data-cjb-base]');
  var canvas = root.querySelector('[data-cjb-canvas]');
  var ctx = canvas.getContext('2d');
  var nameInput = root.querySelector('[data-cjb-name]');
  var numberInput = root.querySelector('[data-cjb-number]');
  var qtyInput = root.querySelector('[data-cjb-qty]');
  var variantIdInput = root.querySelector('[data-cjb-variant-id]');
  var priceEl = root.querySelector('[data-cjb-price]');
  var errEl = root.querySelector('[data-cjb-err]');
  var submitBtn = root.querySelector('[data-cjb-submit]');

  function money(cents) {
    var amt = (cents / 100);
    var s = amt % 1 === 0 ? amt.toLocaleString('en-IN') : amt.toLocaleString('en-IN', { minimumFractionDigits: 2 });
    // strip any HTML in the money format (e.g. shop's "<span class=money>...</span>")
    // because we assign via textContent and would otherwise show literal tags.
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, s).replace(/<[^>]*>/g, '');
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
  }

  function refreshOptionAvailability() {
    root.querySelectorAll('[data-cjb-optgroup]').forEach(function (group) {
      var gi = parseInt(group.dataset.cjbOptgroup, 10);
      group.querySelectorAll('[data-cjb-opt]').forEach(function (btn) {
        var trial = selected.slice();
        trial[gi] = btn.dataset.value;
        var v = variants.find(function (vr) {
          return vr.options.every(function (val, i) { return val === trial[i]; });
        });
        var ok = v && v.available;
        btn.disabled = !ok;
        btn.setAttribute('aria-pressed', String(btn.dataset.value === selected[gi]));
      });
    });
  }

  function updateVariant() {
    var v = findVariant();
    refreshOptionAvailability();
    if (!v) { priceEl.textContent = 'Unavailable'; variantIdInput.value = ''; submitBtn.disabled = true; return; }
    variantIdInput.value = v.id;
    priceEl.textContent = money(v.price);
    submitBtn.disabled = false;
  }

  function fitFont(text, zone, maxW) {
    var size = zone.font || 48;
    ctx.font = (zone.weight || 800) + ' ' + size + 'px Arial Narrow, Arial, sans-serif';
    while (ctx.measureText(text).width > maxW && size > 8) {
      size -= 2;
      ctx.font = (zone.weight || 800) + ' ' + size + 'px Arial Narrow, Arial, sans-serif';
    }
  }

  function drawText(text, zone) {
    if (!text || !zone) return;
    var w = canvas.width, h = canvas.height;
    var maxW = (zone.w || 0.5) * w;
    fitFont(text, zone, maxW);
    ctx.fillStyle = zone.color || '#1c1b1b';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, (zone.x || 0.5) * w, (zone.y || 0.3) * h);
  }

  function render() {
    // Prefer the base image's box; fall back to the stage so the canvas never
    // collapses to 0 height when the product has no image (keeps name/number preview working).
    var stage = (canvas && canvas.parentElement) || root;
    var w = (baseImg && baseImg.clientWidth) || stage.clientWidth || 0;
    var h = (baseImg && baseImg.clientHeight) || Math.round(((baseImg && baseImg.clientWidth) || stage.clientWidth || 0) * 1.2);
    if (!w || !h) return;
    canvas.width = w; canvas.height = h;
    ctx.clearRect(0, 0, w, h);
    drawText((nameInput.value || '').toUpperCase(), zones.name);
    drawText((numberInput.value || '').replace(/\D/g, ''), zones.number);
  }

  function clampQty() {
    var v = parseInt(qtyInput.value, 10);
    if (isNaN(v) || v < moq) { qtyInput.value = moq; }
  }

  // Events
  root.querySelectorAll('[data-cjb-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var gi = parseInt(btn.closest('[data-cjb-optgroup]').dataset.cjbOptgroup, 10);
      selected[gi] = btn.dataset.value;
      updateVariant();
    });
  });
  nameInput.addEventListener('input', render);
  numberInput.addEventListener('input', function () {
    numberInput.value = numberInput.value.replace(/\D/g, '');
    render();
  });
  qtyInput.addEventListener('change', clampQty);
  if (baseImg) {
    if (baseImg.complete) render();
    baseImg.addEventListener('load', render);
  }
  window.addEventListener('resize', render);
  render(); // initial paint even when no base image is set yet

  var form = root.querySelector('[data-cjb-form]') || root.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      clampQty();
      if (!variantIdInput.value) { e.preventDefault(); errEl.textContent = 'Please choose fabric and size.'; return; }
      if (parseInt(qtyInput.value, 10) < moq) { e.preventDefault(); errEl.textContent = 'Minimum order is ' + moq + ' units.'; return; }
      errEl.textContent = '';
    });
  }

  // Optional Gemini realistic render
  var renderBtn = root.querySelector('[data-cjb-render]');
  if (renderBtn) {
    renderBtn.addEventListener('click', function () {
      var endpoint = root.dataset.renderEndpoint;
      if (!endpoint || !baseImg) return;
      root.classList.add('is-rendering');
      renderBtn.disabled = true;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image: baseImg.currentSrc || baseImg.src,
          name: (nameInput.value || '').toUpperCase(),
          number: (numberInput.value || '').replace(/\D/g, '')
        })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.image) {
            baseImg.src = data.image;
            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
          }
        })
        .catch(function () { errEl.textContent = 'Could not generate render. The instant preview is still accurate.'; })
        .finally(function () { root.classList.remove('is-rendering'); renderBtn.disabled = false; });
    });
  }

  updateVariant();
})();
